var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content-assesssment-info pb-3"},_vm._l((_vm.questions),function(item,index){return _c('QuestionCard',{key:index,attrs:{"question_index":index,"question_id":item.id,"question":item.question,"question_difficulty":item.difficulty,"question_type":item.type,"question_duration":item.duration + 's',"question_data":item,"question_options":[
        {
          id: 'a',
          value: item.option_a,
          correct: item.answer.toLowerCase() == 'a',
        },
        {
          id: 'b',
          value: item.option_b,
          correct: item.answer.toLowerCase() == 'b',
        },
        {
          id: 'c',
          value: item.option_c,
          correct: item.answer.toLowerCase() == 'c',
        },
        {
          id: 'd',
          value: item.option_d,
          correct: item.answer.toLowerCase() == 'd',
        } ],"selected":_vm.isSelected(item.id)},on:{"pickQuestion":_vm.pickQuestion,"removeQuestion":_vm.removeQuestion,"toggleFeedback":_vm.toggleFeedbackModal}})}),1),(_vm.preview_modal)?_c('AssessmentPreviewModal',{attrs:{"question":_vm.question,"question_options":[
      {
        id: 'a',
        value: _vm.question.option_a,
        correct: _vm.question.answer.toLowerCase() == 'a',
      },
      {
        id: 'b',
        value: _vm.question.option_b,
        correct: _vm.question.answer.toLowerCase() == 'b',
      },
      {
        id: 'c',
        value: _vm.question.option_c,
        correct: _vm.question.answer.toLowerCase() == 'c',
      },
      {
        id: 'd',
        value: _vm.question.option_d,
        correct: _vm.question.answer.toLowerCase() == 'd',
      } ]},on:{"closeTriggered":_vm.togglePreviewModal,"clickFeedbackForm":_vm.toggleFeedbackModal}}):_vm._e(),(_vm.feedback_modal)?_c('AssessmentFeedbackModal',{on:{"closeTriggered":_vm.toggleFeedbackModal,"showAlertInfo":function($event){return _vm.showAlert($event.msg, $event.type)}}}):_vm._e(),(_vm.response_dialog)?_c('ResponseDialog',{attrs:{"alert_msg":_vm.alert_card_msg,"alert_type":_vm.alert_card_type},on:{"closeAlert":_vm.toggleResponseDialog}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }